module.exports = __webpack_public_path__ + "static/media/Monopoly_C_HC.dd3cb50d.png";